{  
    "title":"Edit User",
    "user":{
        "firstName":{
            "title":"First Name",
            "class": "form-group col-6 lg:col-4",
            "sortIndex": 0
        },
        "lastName" : {
            "title": "Last Name",
            "class": "form-group col-6 lg:col-4",
            "sortIndex": 1
        },
        "email" : {
            "title":"Email",
            "class": "form-group col-6 lg:col-4",
            "sortIndex": 2
        },
        "username": {
            "title": "User Name",
            "class": "form-group col-6 lg:col-4",
            "inputType":"text"

        },
        "status" : {
            "title":"Status",
            "class": "form-group col-6 lg:col-4",
            "statusValues": ["Active","Inactive"],
            "sortIndex": 3
        },
        "department":{
            "title": "Department",
            "class": "form-group col-6 lg:col-4"
        },
        "division":{
            "title": "Division",
            "class": "form-group col-6 lg:col-4"
        },
        "cancelBtn":{
            "title": "Cancel",
            "sortIndex": 6
        },
        "updateBtn":{
            "title":"Update",
            "sortIndex": 7
        },
        "mobileNo":{
            "title":"Mobile Number",
            "sortIndex": 8
        },
        "placeHolder":{
            "firstName":{
                "label":"Enter First Name"
            },
            "lastName":{
                "label": "Enter Last Name"
            },
            "userName":{
                "label":"Enter UserName"
            },
            "email":{
                "label": "Email"
            },
            "mobileNo":{
                "label":"Enter mobile No"
            },
            "department":{
                "label":"Select or enter Department"
            },
            "division":{
                "label":"Select or enter Division"
            },
            "sortIndex": 8
        }
    }
}
    